module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    class: {
      error: _vm.errorMsg
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMsg),
      expression: "errorMsg"
    }],
    staticClass: "page-error"
  }, [_c('img', {
    attrs: {
      "src": "https://img.thebeastshop.com/images/wap/page-error/page-error.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "reload",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("重新加载")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749c0efa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/app-main/index.vue
// module id = 163
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 17 19 23 27 28 30 36 39 40 44 45 53 80